export const RUBIC_X_API_OKU_BASE_URL = 'https://x-api.rubic.exchange/oku/api/market';
export const RUBIC_X_API_APIKEY = 'sndfje3u4b3fnNSDNFUSDNVSunw345842hrnfd3b4nt4';
